<template>
  <div>
    <DynamicComponent edc-id="poloris-performance-assessment" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'PolarisPerformanceAssessment',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
